<template>
    <TMemu>
        <template #modal>
            <OMobileMessage
                v-if="messageTitle"
                :title="messageTitle"
                :description="messageDescription"
            />
            <OMenuHeader
                title="storo storsenter"
                description="Interactive map over"
            />
        </template>
        <template #header>

        </template>
        <template #main>
            <div class="mobile-menu-items">
                <template
                    v-for="(item, i) in menuItems"
                >
                    <OMenuItem
                        :key="item.id"
                        v-if="isItemShow(i)"
                        :locale="locale"
                        :item="item"
                        mode="mobile"
                    />
                </template>
            </div>
        </template>
        <template #footer>
            <div class="mobile-menu-footer">
                <ACopyRight />
            </div>
        </template>
    </TMemu>
</template>

<script>
import '../../../assets/images/generated-svg';

import {
    mapState,
    mapGetters
} from 'vuex';

import TMemu from '../../templates/t-menu/t-menu';
import ACopyRight from '../../atoms/a-copy-right/a-copy-right';
import OMenuItem from '../../organisms/o-menu-item/o-menu-item';
import OMenuHeader from '../../organisms/o-menu-header/o-menu-header';
import OMobileMessage from '../../organisms/o-mobile-message/o-mobile-message';

import { Storage } from "../../../utils/services/storage-service";
import { SET_ACTIVE_VIEW } from "@/shared/components/map-viewer/constants/map-commands";
import { MENU_REDIRECT_URL } from "../../../utils/constants/app-constants";

export default {
    name: 'PMobileMenu',
    components: {
        TMemu,
        OMenuItem,
        OMenuHeader,
        ACopyRight,
        OMobileMessage,
    },
    data() {
        return {
            modalOrganism: null
        }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale,
            isLandscape: state => state.landscape,
            messageTitle: state => state.map.meta.otg_emergency_banner_header,
            messageDescription: state => state.map.meta.otg_emergency_banner_text,
        }),
        ...mapGetters({
            'menuItems': 'getMenuItems',
        }),
    },
    mounted() {
        this.$bus.$emit(SET_ACTIVE_VIEW, 'ShowreelView');
        this.clearStorage();
    },
    methods: {
        isItemShow(index) {
            return this.isLandscape ? index < 3 : true;
        },
        clearStorage() {
            Storage.local.remove(MENU_REDIRECT_URL);
        }
    }
}
</script>

<style lang="scss" src="./p-mobile-menu.scss" />